'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var documentPreviewPopin = {
  template: require("./documentPreviewPopin.html"),
  controller: "DocumentPreviewCtrl",
  options: {
    width: 1000
  }
};
ngModule.controller("DocumentPreviewCtrl", function ($scope, $element) {
  $scope.maximizeWindow = function () {
    var dialogEl = $element.find(".tl-modal-content");
    if (dialogEl == null) {
      return;
    }
    dialogEl.addClass("full-size");
    $scope.initialWidth = dialogEl.css("width");
    dialogEl.css("width", "");
    $scope.maximized = true;
  };
  $scope.restoreWindow = function () {
    var dialogEl = $element.find(".tl-modal-content");
    if (dialogEl == null) {
      return;
    }
    dialogEl.removeClass("full-size");
    dialogEl.css("width", $scope.initialWidth);
    $scope.maximized = false;
  };
});
ngModule.factory("documentPreview", function ($modal, fileUtils) {
  var supportedExtensions = [].concat(_toConsumableArray(fileUtils.getImagesExtensions()), _toConsumableArray(fileUtils.getPdfExtensions()), _toConsumableArray(fileUtils.getMsgExtensions()));
  return {
    canPreview: function canPreview(document) {
      var extension = fileUtils.getExtension(document.fileId ? document.fileId : document.url);
      //console.log('extension', extension);
      return _.includes(supportedExtensions, extension);
    },
    /**
     *
     * @param document
     * @param documentViewUrl optionnel, permet de préciser quelle url renvoie le document (/${document.id} sera ajouté automatiquement si l'documentViewUrl ne contient pas de ?), par defaut c'est /rest/documents/view/${document.id}
     * @returns {*}
     */
    openPopin: function openPopin(document, documentViewUrl) {
      return $modal.open(_objectSpread({}, documentPreviewPopin, {
        vars: {
          document: document,
          documentViewUrl: documentViewUrl
        }
      }));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/documentPreview.js
// module id = 2774
// module chunks = 13